import cx from "classnames";
import React, { useEffect, useState } from "react";

import styles from "./PartLoader.module.scss";

type PartLoaderProps = {
  block?: boolean;
  active?: boolean;
  delay?: number;
  transitionDuration?: number;
  children: React.ReactNode;
  className?: string;
};

const PartLoader: React.FC<PartLoaderProps> = ({
  block = false,
  active = false,
  delay = 0,
  transitionDuration = 0,
  children,
  className,
}) => {
  const [activeInternal, setActiveInternal] = useState<boolean>(active);
  let timeoutRef: ReturnType<typeof setTimeout> | undefined;

  useEffect(() => {
    if (active && delay) {
      timeoutRef = setTimeout(() => {
        setActiveInternal(true);
        timeoutRef = undefined;
      }, delay);
      return () => {
        if (timeoutRef) clearTimeout(timeoutRef);
      };
    }

    if (active) {
      setActiveInternal(true);
      return;
    }

    if (!active && timeoutRef) {
      clearTimeout(timeoutRef);
      timeoutRef = undefined;
    }
    setActiveInternal(false);
  }, [active, delay]);

  return (
    <div
      className={cx(
        styles.loader,
        {
          [styles.loader_active]: activeInternal,
          [styles.loader_block]: block,
        },
        className,
      )}
    >
      <div
        className={styles.loader__wrapper}
        style={{
          transition: transitionDuration
            ? `opacity ${transitionDuration}ms ease`
            : undefined,
        }}
      >
        {children}
      </div>
      {activeInternal ? (
        <div className={styles.loader__spinner}>
          <i></i>
          <i></i>
          <i></i>
        </div>
      ) : (
        <div />
      )}
    </div>
  );
};

export default PartLoader;
